package globals

import structs.Commander
import structs.Player
import structs.World

/**
 * Global object that houses the client side world data for a game map. This is used locally to display
 * stats, and other information about the game world from the server.
 */
object World
{
    var worldData = World()
    var localPlayer = Player()
    /**
     * Commander owned by the authenticated browser session. Gameplay may
     * rotate [localPlayer] to the current turn actor for the shared-board
     * presentation, but ownership-sensitive actions (for example surrender)
     * must continue to target this stable commander.
     */
    var controlledPlayerName = ""
    var availableCommanders: MutableList<Commander> = mutableListOf()
    var isPlayerTurn = false //Defines if it's the player's turn.
    var canPlayerAct = false //Linked to the above variable. Defines if the player can issue play prompts.
    var activeTurnActor = ""
}
